<template>
	<div>
		<br/>
		<el-row type="flex">
			<el-col align="left" v-if="step>0">
				<el-button style="min-width: 100px"
				           type="info"
				           @click="beforeAlias()"><i class="el-icon-arrow-left"></i>
					Atrás
				</el-button>
			</el-col>

			<el-col align="right" v-if="step != 6">

				<el-button style="min-width: 100px" @click="submitForm(null)" type="info">
					Siguiente <i class="el-icon-arrow-right"></i>
				</el-button>
			</el-col>

		</el-row>


	</div>
</template>

<script>
	export default {
		props:{
			step:{
				required: true
			},
			beforeAlias:{
				required: true
			},
			submitForm: {
				required: true
			},

		}
	}
</script>

<style scoped>

</style>